module.exports = __webpack_public_path__ + "img/Georgia.de4bbf33.svg";